module.exports = __webpack_public_path__ + "parcs_bonobo.png?6dd8a270df2ced90d1c28c70a14be06e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/parcs_bonobo.png
// module id = 8
// module chunks = 13